import { SearchResultAppointmentSummary, SearchResultAppointment } from '../../search/types';
import { getLocalizedBookingDateTime } from './getLocalizedBookingDateTime';

export const getLocalizedAppointmentSummary = (
  appointmentSummary: SearchResultAppointmentSummary,
  timezone?: string,
): SearchResultAppointmentSummary => {
  const firstAppointment: SearchResultAppointment | undefined =
    appointmentSummary?.firstAppointment;

  if (!firstAppointment || !firstAppointment.date || !firstAppointment.time || !timezone) {
    return appointmentSummary;
  }

  const { date, time } = getLocalizedBookingDateTime(
    firstAppointment?.date,
    firstAppointment?.time,
    timezone,
  );

  const localizedAppointment: SearchResultAppointment = {
    ...firstAppointment,
    date,
    time,
  };

  return {
    ...appointmentSummary,
    firstAppointment: localizedAppointment,
  };
};
